import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGoogle = () => {
  return (
    <g>
      <path d="m15.06 7.34h-6.8181v2.0054h4.8523c-.2368 2.8126-2.5768 4.0121-4.7856 4.0121a5.2707 5.2707 0 0 1 -5.2919-5.34 5.28 5.28 0 0 1 5.2982-5.374 5.2027 5.2027 0 0 1 3.6139 1.45l1.4044-1.4543a7.14 7.14 0 0 0 -5.0902-2.007 7.49 7.49 0 0 0 -7.425 7.35 7.4656 7.4656 0 0 0 7.532 7.3856 6.4875 6.4875 0 0 0 6.832-6.6983 6.0112 6.0112 0 0 0 -.122-1.3295z" />
      <path d="m15.06 7.339v.001z" />
    </g>
  );
};

export default withIcon(IconLogoGoogle);
